import ActionButton from 'components/shared/Button/ActionButton/ActionButton';

const CustomPopoverButton = ({ open, requestCount }) => {
  return (
    <div className="relative flex items-center">
      <ActionButton color="#ff00000" icon="kiosk-mono" active={open} />
      {requestCount > 0 && (
        <div className="absolute right-[6px] top-[5px] flex h-[6px] min-w-[6px] items-center justify-center rounded-full bg-danger-400 p-[2px]" />
      )}
    </div>
  );
};

export default CustomPopoverButton;
